import React from "react";
import * as Icon from 'ubs-icons';

export const PERV_LOCATION_DISTANCE = 50 // in meters
export const IS_DEV = process.env.NODE_ENV === 'development'
export const FCM_CONFIG = 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window
export const ON_BOARDING = false // true, false
export const PRODUCT_ACCESS = {HRMS: true, PMS: true, CHAT: true, PAYROLL: true}
export const imageLink = '/images/reaction/';
export const APP = {
    THUMBOR_URL: process.env.REACT_APP_THUMBOR_URL,
    COOKIE_DAYS: 90,
    SESSION_TIME: 1440, // in Minutes
    TOKEN_EXPIRY: 90 * 24* 60 * 60, // 90 days
    REFRESH_TOKEN_EXPIRY: 24* 60 * 60, // 90 days
    IST_OFFESET : -330,
    DEFAULT_TZ : 'Asia/Kolkata',
    UTC_TZ: 'GMT',

};

export const REGEX = {
    AT: /(\<@(.*?)\|(.*?)\>)/gim,
    OBJECT_ID: /^[a-f0-9]{24}$/,
    EMOJI: /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g,
    ACTIVITY: /(\<\$(.*?)\|(.*?)\>)/gim,
    EMOJI_SKIN: /(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)/gim,
    ALPHANUMERIC: /^[a-zA-Z0-9 -]{1,25}$/i,
    NAME: /^([a-zA-Z ' -]{1,100})$/i,
    EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i,
    PHONE: /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i,
    ADDRESS_DEPARTMENT: /^[a-zA-Z0-9 ' , . & -]{1,100}$/i,
    CITY: /^[a-zA-Z]+(?:[\s-][a-zA-Z]{1,100})*$/i,
    COMPANY: /^([-a-zA-Z0-9 ' , . & !]{1,100})$/i,
    POSTCODE: /^\d{6}(?:[-\s]\d{4})?$/i,
    IFSCCODE: /^[a-zA-Z0-9 -]{3,18}$/i,  /*/^[A-Z]{4}0[A-Z0-9]{6}$/i*/
    NUMBER: /^\d{3,50}$/i,
    BANK: /^([a-zA-Z]{1,50})$/i,
    number: /\d/, // /^(?=.*?[0-9])/,
    upperCase: /[A-Z]/, // /^(?=.*?[A-Z])/,
    lowerCase: /[a-z]/, // /^(?=.*?[a-z])/,
    specialChar: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
};
export const FILE = {
    IMAGES: /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i,
    VIDEO: /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i,
    AUDIO: /\.(mp3|wav|ogg|wma|m4a|flac|mp2|aac|aiff|m4r|amr|ac3|opus|gsm|wve|w64|caf|fssd|vox|dts|amb|txw|au|spx|wv|voc|tta|ra|oga|pvf|prc|maud|8svx|snd|sndr|sndt|avr|cdda|cvs|cvsd|cvu|dvms|vms|fap|paf|sou|gsrt|hcom|htk|ima|ircam|sln|sph|nist|smp|sd2)$/i,
    EXCLUDES: ['exe', 'EXE', 'dmg', 'msi'],
    DOCS: /\.(doc|docx|DOC|DOCX|pdf|PDF|js)$/i,
    MIXFILES: /\.(png|apng|jpeg|jpg|pdf|PDF)$/i,
    MIXDOC: /\.(png|apng|jpeg|jpg|pdf|PDF|doc|docx|DOC|DOCX|xlsx|xls|rtf)$/i,
    ELSXFILES: /\.(xlsx|XLSX)$/i,
    ZIPFILE: /\.(zip)$/i,
};
export const FORMAT = {
    TIME: 'hh:mm A',
    TIME_FORMAT_24: 'HH:mm',
    MONTH: 'MM/YYYY',
    DATE: 'DD/MM/YYYY',
    DUE_DATE: 'DD MMM, YY',
    TICKET_DATE: 'DD MMM, YYYY',
    DAY_TIME: 'dddd hh:mm A',
    DATE_TIME: 'DD/MM/YYYY hh:mm A',
    DATE_TIME_24: 'DD/MM/YYYY HH:mm',
    FULL_DATE: 'dddd, MMMM D, YYYY',
    YEAR_MONTH: 'MMMM, YYYY',
    MONTH_DATE: 'MMM DD, YYYY',
    MONTH_DATE_TIME: 'MMM DD, YYYY, hh:mm A',
    MONTH_DATE_TIME_24: 'MMM DD, YYYY, HH:mm',
    DAY_DATE: 'ddd, MMM DD, YYYY',
    DOC_DATE_FORMAT: 'do, MMM yyyy',
    DAY_DATE_MONTH: 'ddd DD MMM, YYYY',
    FULL_DATE_TIME: 'ddd DD MMM, YYYY hh:mm A',
    FULL_DATE_TIME_24: 'ddd DD MMM, YYYY HH:mm',
    FULL_DATE_KIT_TIME: 'DD MMM YYYY (dddd)',
    ATS_DATE:'DD MMM YYYY, dddd hh:mm A'
};
export const COLOR = {
    u_title: '#1e2538',
    u_font: '#73788b',
    u_blue: '#007AFF',
    u_lightfont: '#c7c7c7',
    u_gray: '#e4e4e4',
    u_dark_gray: '#7b849e',
    u_datepicker_bg: '#fafbff',
    u_thead_bg: '#fafafb',
    u_icon_bg: '#4E525F',
    u_lightgreen: '#F8FDF8',
    u_darkfont: '#5D6372',
    u_semilight_gray: '#F8F9FE',
    u_white: '#FFFFFF',
    u_green: '#60B158',
    u_orange: '#FFA700',
    u_pastelred: '#FF6961',
    u_black: '#000000',
    u_red: '#FF6961',
    u_purple: '#9A5BFF',
    u_lightblue: '#33D6FA',
    $u_bg: '#F5F6FA',
}
export const LIMIT = {
    SEARCH_CHARACTER: 2,
    TOAST_TIME_OUT: 5000,
    DE_BOUNCING_TIME_OUT: 500,
    DE_BOUNCING_TIME_OUT_TICKET: 1000,
    TOOLTIP_DELAY: 500,
    PAGINATION: 25,
};
export const PAGINATION = {
    CURRENT_PAGE: 1,
    LIMIT: 40,
    LIMIT100: 100,
}
export const RECORDPERPAGE = [
    {value: 20, label: '20'},
    {value: 40, label: '40'},
    {value: 60, label: '60'},
    {value: 80, label: '80'},
    {value: 100, label: '100'},
];
export const HRMS_STATUS = {
    HOLIDAY: {
        FULL_DAY: 1,
        FIRST_HALF: 2,
        SECOND_HALF: 3,
    },
    WEEK_DAY: {
        SUNDAY: 0,
        MONDAY: 1,
        TUESDAY: 2,
        WEDNESDAY: 3,
        THURSDAY: 4,
        FRIDAY: 5,
        SATURDAY: 6,
    },
    WEEK_NUMBER: [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
    ],
    TAG_CODES: ["st", "nd", "rd", "th", "th", "th"],
    WEEKEND_TYPE: {
        WORK: 0,
        FIRSTHALF: 1,
        SECONDHALF: 2,
        FULLDAY: 3,
    },
    DAY_NUMBER: {
        FIRST: 1,
        SECOND: 2,
        THIRD: 3,
        FOURTH: 4,
        FIFTH: 5,
    },
    TIME_SHEET_TYPE: {
        WORK: 1,
        BREAK: 2,
    },
    TIME_SHEET_REQUEST_STATUS: {
        PENDING: 1,
        APPROVED: 2,
        REJECTED: 3,
        CANCELLED: 4,
    },
    TIME_SHEET_REQUEST_TYPE: {
        ADD: 1,
        UPDATE: 2,
    },
    DAILY_REPORT_TIME_STATUS: {
        INITIAL: 1,
        WORK: 2,
        BREAK: 3,
        END: 4,
    },
    DAILY_REPORT_STATUS: {
        PENDING: 1,
        COMPLETE: 2,
        REQUESTED: 3,
        LEAVE_REQUESTED: 4,

        /** Attendance Popup Constants */
        LEAVE_EARLY_OUT: 5,
        EARLY_OUT: 6,
    },
    DAILY_REPORT_DAY_STATUS: {
        HOLIDAY: 1,
        WEEKEND: 2,
        WORKING: 3,
        FIRST_HALF_WORKING: 4,
        SECOND_HALF_WORKING: 5,
        FULL_DAY_LEAVE: 6,
        FIRST_HALF_LEAVE: 7,
        SECOND_HALF_LEAVE: 8,
        PRESENT_BY_DEFAULT: 9,
        NON_WORKING: 10,
        FIRST_HALF_NON_WORKING: 11,
        SECOND_HALF_NON_WORKING: 12,
    },
    LEAVE_TYPE: {
        FULL_DAY: 1,
        FIRST_HALF: 2,
        SECOND_HALF: 3,
        HOURLY: 4,
        SHORT: 5,
    },
    DROPDOWN_LIST_TYPE: {
        PROJECT: 1,
        TASK: 2,
        ACTIVITY: 3,
        USER: 4,
    },
    FINAL_OUT_TYPE: {
        MANUAL: 1,
        AUTO: 2,
    },
    TIME_SHEET_ADDED_TYPE: {
        MANUAL: 1,
        AUTO: 2,
    },
    PROJECT_WORK_LOG_ADDED_TYPE: {
        MANUAL: 1,
        AUTO: 2,
    },
    SEARCH_IN_TYPE: {
        PROJECT: 1,
        PROJECT_TASK: 2,
        PROJECT_ACTIVITY_TYPE: 3,
    },
    SHIFT_TOTAL_HOUR_CALCULATION_TYPE: {
        FIRST_LAST_CHECK_OUT: 1,
        EVERY_CHECK_OUT: 2,
    },
    OVER_TIME_PAY_TYPE: {
        HOURS: 1,
        FIXED: 2,
    },
    OVER_TIME_LEVEL1: {
        USER: 1,
        UAC: 2,
    },
};
export const LOGIN_METHOD = {
    WEB: 1,
    MOBILE: 2,
    DESKTOP: 3,
    FACE_CLOCK_IN: 4,
    BIOMETRIC: 5,
    GEO_TAGGING: 6,
    CLOCK_IN_WITH_SELFIE: 7,
}
export const CONSTANT = {
    COLORS: [
        "#1d873f",
        "#0f7fff",
        "#ffa801",
        "#fe6f5e",
        "#8e3b99",
        "#618b8c",
        "#ff55a3",
        "#009e60",
        "#DF73FF",
        "#ffb871",
        "#6495ed",
        "#45b1e8",
        "#77dd77",
        "#9c8e8e",
        "#7F5417",
        "#2377a2",
        "#f3ac76",
        "#917214",
        "#96ded1",
        "#000000",
        "#167f71",
        "#191970",
        "#747880",
        "#507389",
        "#EBA83A",
        "#0BC198",
        "#004B23",
        "#867AE9",
        "#1C045C",
        "#50808E",
        "#C449C2",
        "#423F62",
        "#E500A4",
        "#064420",
        "#3C78ED",
        "#A100F2",
        "#FC5404",
        "#B25A65",
        "#08BB90",
        "#1EAE98",
        "#204969",
        "#A5BE00",
        "#4AA96C",
        "#CA3E47",
        "#7678ED",
        "#939B62",
        "#A64942",
        "#0A85ED",
        "#FFB26B",
        "#2EC4B6",
        "#D7816A",
        "#4A503D",
        "#240046",
        "#EE4266",
        "#E28F83",
        "#9D4EDD",
        "#0EAD69",
        "#3F3697",
        "#892B64",
        "#1DD3B0",
        "#3EDBF0",
        "#F94144",
        "#5C6854",
        "#F21170",
        "#E09F3E",
        "#F27F34",
        "#02475E",
        "#FF6D00",
        "#FF8C90",
        "#C67ACE",
        "#358F80",
        "#2E7094",
        "#0061A8",
        "#2B9348",
        "#73A280",
        "#7B6079",
        "#583101",
        "#921818",
        "#FF96AD",
        "#200A84",
        "#007200",
        "#005A8D",
        "#3D6C73",
        "#A2873C",
        "#00EAD3",
        "#2E4952",
        "#61574B",
        "#0A81AB",
        "#D65131",
        "#FFA5AB",
        "#FF449F",
        "#743C2C",
        "#DA627D",
        "#BB371A",
        "#1584D4",
        "#A53860",
        "#4A1C40",
        "#716AA0",
        "#754F5B",
        "#E798AE",
        "#E44477",
        "#E2711D",
        "#185ADB",
        "#4DC242",
        "#5BC0BE",
        "#99154E",
        "#FF6682",
        "#00B2CA",
        "#CF0000",
        "#5239E0",
        "#72147E",
        "#69A297",
    ],
    COLOR_ARRAY: [
        {label: '#1d873f', value: '#1d873f'},
        {label: '#0f7fff', value: '#0f7fff'},
        {label: '#ffa801', value: '#ffa801'},
        {label: '#fe6f5e', value: '#fe6f5e'},
        {label: '#747880', value: '#747880'},
        {label: '#8e3b99', value: '#8e3b99'},
        {label: '#618b8c', value: '#618b8c'},
        {label: '#ff55a3', value: '#ff55a3'},
        {label: '#009e60', value: '#009e60'},
        {label: '#DF73FF', value: '#DF73FF'},
        {label: '#ffb871', value: '#ffb871'},
        {label: '#6495ed', value: '#6495ed'},
        {label: '#45b1e8', value: '#45b1e8'},
        {label: '#77dd77', value: '#77dd77'},
        {label: '#9c8e8e', value: '#9c8e8e'},
        {label: '#7F5417', value: '#7F5417'},
        {label: '#2377a2', value: '#2377a2'},
        {label: '#f3ac76', value: '#f3ac76'},
        {label: '#917214', value: '#917214'},
        {label: '#96ded1', value: '#96ded1'},
        {label: '#000000', value: '#000000'},
        {label: '#167f71', value: '#167f71'},
        {label: '#191970', value: '#191970'},
        {label: '#fe6f5e', value: '#fe6f5e'},
        {label: '#747880', value: '#747880'},
        {label: '#507389', value: '#507389'},
        {label: '#FFA700', value: '#FFA700'},
        {label: '#007AFF', value: '#007AFF'},
    ],
    Frequency: [
        {label: 'Daily', value: 2},
        {label: 'Weekly', value: 3},
        {label: 'Monthly', value: 4},
    ],

    optionsList: [
        {
            label: 'Single line text',
            image: <Icon.Minus size={18} fill={COLOR.u_title}/>,
            value: 'singleline',
            question: ``,
            hint: ``,
            type: 1,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Multi line text',
            image: <Icon.Multiline size={18} fill={COLOR.u_title}/>,
            value: 'multiline',
            question: ``,
            hint: ``,
            type: 2,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Yes/No',
            image: <Icon.YesNo size={18} fill={COLOR.u_title}/>,
            value: 'yes/no',
            question: ``,
            hint: ``,
            type: 3,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Single choice',
            image: <Icon.CheckMark size={18} fill={COLOR.u_title}/>,
            value: 'singlechoice',
            question: ``,
            hint: ``,
            type: 4,
            required: false,
            isSection: false,
            isOtherOption: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "Answer 1",
                value: "Answer 1"
            }, {
                label: "Answer 2",
                value: "Answer 2"
            }]
        },
        {
            label: 'Multiple choice',
            image: <Icon.DoubleTick size={18} fill={COLOR.u_title}/>,
            value: 'multiplechoise',
            question: ``,
            hint: ``,
            type: 5,
            required: false,
            isOtherOption: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "Answer 1",
                value: "Answer 1"
            }, {
                label: "Answer 2",
                value: "Answer 2"
            }],
        },
        {
            label: 'Dropdown',
            image: <Icon.ListData size={18} fill={COLOR.u_title}/>,
            value: 'dropdown',
            question: ``,
            hint: ``,
            type: 6,
            required: false,
            isSection: false,
            isOtherOption: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "Answer 1",
                value: "Answer 1"
            }, {
                label: "Answer 2",
                value: "Answer 2"
            }]
        },
        {
            label: 'Gender',
            image: <Icon.Gender size={18} fill={COLOR.u_title}/>,
            value: 'gender',
            question: ``,
            hint: ``,
            type: 7,
            required: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "Male",
                value: "Male"
            }, {
                label: "Female",
                value: "Female"
            }]
        },
        {
            label: 'Email',
            image: <Icon.Mail size={18} fill={COLOR.u_title}/>,
            value: 'email',
            question: ``,
            hint: ``,
            type: 8,
            required: false,
            errorMessage: 'This question is mandatory',
        },
        {
            label: 'Number',
            image: <Icon.ListData size={18} fill={COLOR.u_title}/>,
            value: 'number',
            question: ``,
            hint: ``,
            type: 9,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Date',
            image: <Icon.Calendar size={18} fill={COLOR.u_title}/>,
            value: 'date',
            question: ``,
            hint: ``,
            type: 10,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Address',
            image: <Icon.Location size={18} fill={COLOR.u_title}/>,
            value: 'address',
            question: ``,
            hint: ``,
            type: 11,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Slider scale',
            image: <Icon.CozyView size={18} fill={COLOR.u_title}/>,
            value: 'sliderscale',
            question: ``,
            hint: ``,
            type: 12,
            required: false,
            start: "",
            end: "",
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Star rating',
            image: <Icon.StarFill size={18} fill={COLOR.u_title}/>,
            value: 'starrating',
            question: ``,
            hint: ``,
            type: 13,
            required: false,
            NA: false,
            errorMessage: 'This question is mandatory',
            noOfRange: 0,
            rating: [
                {value: 5, label: '05'},
                {value: 10, label: '10'}
            ]
        },
        {
            label: 'NPS',
            image: <Icon.NPS size={18} fill={COLOR.u_title}/>,
            value: 'nps',
            question: ``,
            hint: ``,
            startScale: ``,
            endScale: ``,
            type: 14,
            required: false,
            notApplicable: false,
            errorMessage: 'This question is mandatory',
            optionList1: [
                {value: 'Smileys', label: 'Smileys'},
                {value: 'Boxes', label: 'Boxes'},
                {value: 'Circles', label: 'Circles'}
            ],
            optionList2: [
                {value: '2color', label: '😀', link: `Smileys`},
                {value: '3color', label: '3 Colors', link: `Smileys`},
                {value: 'customcolor', label: 'Custom Colors', link: `Smileys`},
                {value: 'Boxes', label: 'Boxes', link: `Boxes`},
                {value: 'Boxes', label: 'Boxes', link: `Boxes`},
                {value: 'Circles', label: 'Circles', link: `Circles`},
                {value: 'Circles', label: 'Circles', link: `Circles`}
            ]
        },
        {
            label: 'Info box',
            image: <Icon.InfoTooltip size={18} fill={COLOR.u_title}/>,
            value: 'infobox',
            question: ``,
            content: ``,
            type: 15,
            required: false,
            errorMessage: ''
        },
        {
            label: 'Heading/Description',
            image: <Icon.NoTask size={18} fill={COLOR.u_title}/>,
            value: 'headingdesc',
            heading: ``,
            comment: ``,
            type: 16,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'File Upload',
            image: <Icon.Upload size={18} fill={COLOR.u_title}/>,
            value: 'fileupload',
            question: ``,
            hint: ``,
            type: 17,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Scorecard',
            image: <Icon.NotSure size={18} fill={COLOR.u_title}/>,
            value: 'scorecard',
            question: ``,
            hint: ``,
            type: 18,
            required: false,
            errorMessage: 'This question is mandatory',
            isOtherOption: false,
            menuOptions: [{
                label: "",
                value: ""
            }, {
                label: "",
                value: ""
            }],
        },
    ],
    MONTHFREQUENCY: [
        {label: 'Select Days', value: ''},
        {label: 'Annual day', value: 1},
        {label: 'Monthly on the second Tuesday', value: 2},
    ],
    AnalyticsFrequency: [
        {label: 'Today', value: 1},
        {label: 'Weekly', value: 2},
        {label: 'Monthly', value: 3},
        {label: 'Yearly', value: 4},
    ],
    GENDER: [
        {"value": 1, "label": "Male"},
        {"value": 2, "label": "Female"},
        {"value": 3, "label": "Other"},
    ],
    GENDER_LIST: [
        {"value": 'male', "label": "Male"},
        {"value": 'female', "label": "Female"},
        {"value": 'other', "label": "Other"},
    ],
    MARITAL_STATUS: [
        {label: "Married", value: 1},
        {label: "Unmarried", value: 2},
    ],
    MARITAL_STATUS_LIST: [
        {label: "Married", value: "married"},
        {label: "Unmarried", value: "unmarried"},
    ],
    TASK_DUE_DATE: [
        {value: 'beforeToday', label: 'Before today'},
        {value: 'today', label: 'Today'},
        {value: 'tomorrow', label: 'Tomorrow'},
        {value: 'thisWeek', label: 'This week'},
        {value: 'nextWeek', label: 'Next week'},
        {value: 'next14', label: 'Next 14 days'},
        {value: 'customDate', label: 'Custom Date'},
    ],
    RECURRENCE_TYPE: {
        DAILY: 1,
        WEEKLY: 2,
        MONTHLY: 3,
        YEARLY: 4,
        PERIODICALLY: 5,
        CUSTOM: 6,
        CUSTOM_WEEKLY: 2,
        CUSTOM_MONTHLY: 3,
    },
    RECURRENCE_TYPE_LIST: [
        {label: 'Daily', value: 1},
        {label: 'Weekly', value: 2},
        {label: 'Monthly', value: 3},
        {label: 'Yearly', value: 4},
        {label: 'Periodically', value: 5},
        {label: 'Custom', value: 6},
    ],
    EVERY_TYPE: [
        {label: 'Weekly', value: 2},
        {label: 'Monthly', value: 3},
    ],
    DAY: [
        {label: 'Su', value: 0, checked: false},
        {label: 'Mo', value: 1, checked: false},
        {label: 'Tu', value: 2, checked: false},
        {label: 'We', value: 3, checked: false},
        {label: 'Th', value: 4, checked: false},
        {label: 'Fr', value: 5, checked: false},
        {label: 'Sa', value: 6, checked: false},
    ],
    EVERY_DAY: [
        {label: 1, value: 1},
        {label: 2, value: 2},
        {label: 3, value: 3},
        {label: 4, value: 4},
        {label: 5, value: 5},
        {label: 6, value: 6},
        {label: 7, value: 7},
        {label: 8, value: 8},
        {label: 9, value: 9},
        {label: 10, value: 10},
        {label: 11, value: 11},
        {label: 12, value: 12},
    ],
    ON_DAY: [
        {label: 1, value: 1},
        {label: 2, value: 2},
        {label: 3, value: 3},
        {label: 4, value: 4},
        {label: 5, value: 5},
        {label: 6, value: 6},
        {label: 7, value: 7},
        {label: 8, value: 8},
        {label: 9, value: 9},
        {label: 10, value: 10},
        {label: 11, value: 11},
        {label: 12, value: 12},
        {label: 13, value: 13},
        {label: 14, value: 14},
        {label: 15, value: 15},
        {label: 16, value: 16},
        {label: 17, value: 17},
        {label: 18, value: 18},
        {label: 19, value: 19},
        {label: 20, value: 20},
        {label: 21, value: 21},
        {label: 22, value: 22},
        {label: 23, value: 23},
        {label: 24, value: 24},
        {label: 25, value: 25},
        {label: 26, value: 26},
        {label: 27, value: 27},
        {label: 28, value: 28},
        {label: 'Last', value: 'last'},
    ],
    DAYS_AFTER_COMPLETION: [
        {label: 1, value: 1},
        {label: 2, value: 2},
        {label: 3, value: 3},
        {label: 4, value: 4},
        {label: 5, value: 5},
        {label: 6, value: 6},
        {label: 7, value: 7},
        {label: 8, value: 8},
        {label: 9, value: 9},
        {label: 10, value: 10},
        {label: 11, value: 11},
        {label: 12, value: 12},
        {label: 13, value: 13},
        {label: 14, value: 14},
        {label: 15, value: 15},
        {label: 16, value: 16},
        {label: 17, value: 17},
        {label: 18, value: 18},
        {label: 19, value: 19},
        {label: 20, value: 20},
        {label: 21, value: 21},
        {label: 22, value: 22},
        {label: 23, value: 23},
        {label: 24, value: 24},
        {label: 25, value: 25},
        {label: 26, value: 26},
        {label: 27, value: 27},
        {label: 28, value: 28},
        {label: 29, value: 29},
        {label: 30, value: 30},
    ],
    COUNTRY_CODE: [
        {"name": "Afghanistan", "label": "Afghanistan", "dial_code": "+93", "code": "AF"},
        {"name": "Aland Islands", "label": "Aland Islands", "dial_code": "+358", "code": "AX"},
        {"name": "Albania", "label": "Albania", "dial_code": "+355", "code": "AL"},
        {"name": "Algeria", "label": "Algeria", "dial_code": "+213", "code": "DZ"},
        {"name": "Canada", "label": "Canada", "dial_code": "+1", "code": "CA"},
        {"name": "AmericanSamoa", "label": "AmericanSamoa", "dial_code": "+1684", "code": "AS"},
        {"name": "Andorra", "label": "Andorra", "dial_code": "+376", "code": "AD"},
        {"name": "Angola", "label": "Angola", "dial_code": "+244", "code": "AO"},
        {"name": "Anguilla", "label": "Anguilla", "dial_code": "+1264", "code": "AI"},
        {"name": "Antarctica", "label": "Antarctica", "dial_code": "+672", "code": "AQ"},
        {"name": "Antigua and Barbuda", "label": "Antigua and Barbuda", "dial_code": "+1268", "code": "AG"},
        {"name": "Argentina", "label": "Argentina", "dial_code": "+54", "code": "AR"},
        {"name": "Armenia", "label": "Armenia", "dial_code": "+374", "code": "AM"},
        {"name": "Aruba", "label": "Aruba", "dial_code": "+297", "code": "AW"},
        {"name": "Australia", "label": "Australia", "dial_code": "+61", "code": "AU"},
        {"name": "Austria", "label": "Austria", "dial_code": "+43", "code": "AT"},
        {"name": "Azerbaijan", "label": "Azerbaijan", "dial_code": "+994", "code": "AZ"},
        {"name": "Bahamas", "label": "Bahamas", "dial_code": "+1242", "code": "BS"},
        {"name": "Bahrain", "label": "Bahrain", "dial_code": "+973", "code": "BH"},
        {"name": "Bangladesh", "label": "Bangladesh", "dial_code": "+880", "code": "BD"},
        {"name": "Barbados", "label": "Barbados", "dial_code": "+1246", "code": "BB"},
        {"name": "Belarus", "label": "Belarus", "dial_code": "+375", "code": "BY"},
        {"name": "Belgium", "label": "Belgium", "dial_code": "+32", "code": "BE"},
        {"name": "Belize", "label": "Belize", "dial_code": "+501", "code": "BZ"},
        {"name": "Benin", "label": "Benin", "dial_code": "+229", "code": "BJ"},
        {"name": "Bermuda", "label": "Bermuda", "dial_code": "+1441", "code": "BM"},
        {"name": "Bhutan", "label": "Bhutan", "dial_code": "+975", "code": "BT"},
        {
            "name": "Bolivia, Plurinational State of",
            "label": "Bolivia, Plurinational State of",
            "dial_code": "+591",
            "code": "BO"
        },
        {"name": "Bosnia and Herzegovina", "label": "Bosnia and Herzegovina", "dial_code": "+387", "code": "BA"},
        {"name": "Botswana", "label": "Botswana", "dial_code": "+267", "code": "BW"},
        {"name": "Brazil", "label": "Brazil", "dial_code": "+55", "code": "BR"},
        {
            "name": "British Indian Ocean Territory",
            "label": "British Indian Ocean Territory",
            "dial_code": "+246",
            "code": "IO"
        },
        {"name": "Brunei Darussalam", "label": "Brunei Darussalam", "dial_code": "+673", "code": "BN"},
        {"name": "Bulgaria", "label": "Bulgaria", "dial_code": "+359", "code": "BG"},
        {"name": "Burkina Faso", "label": "Burkina Faso", "dial_code": "+226", "code": "BF"},
        {"name": "Burundi", "label": "Burundi", "dial_code": "+257", "code": "BI"},
        {"name": "Cambodia", "label": "Cambodia", "dial_code": "+855", "code": "KH"},
        {"name": "Cameroon", "label": "Cameroon", "dial_code": "+237", "code": "CM"},

        {"name": "Cape Verde", "label": "Cape Verde", "dial_code": "+238", "code": "CV"},
        {"name": "Cayman Islands", "label": "Cayman Islands", "dial_code": "+ 345", "code": "KY"},
        {"name": "Central African Republic", "label": "Central African Republic", "dial_code": "+236", "code": "CF"},
        {"name": "Chad", "label": "Chad", "dial_code": "+235", "code": "TD"},
        {"name": "Chile", "label": "Chile", "dial_code": "+56", "code": "CL"},
        {"name": "China", "label": "China", "dial_code": "+86", "code": "CN"},
        {"name": "Christmas Island", "label": "Christmas Island", "dial_code": "+61", "code": "CX"},
        {"name": "Cocos (Keeling) Islands", "label": "Cocos (Keeling) Islands", "dial_code": "+61", "code": "CC"},
        {"name": "Colombia", "label": "Colombia", "dial_code": "+57", "code": "CO"},
        {"name": "Comoros", "label": "Comoros", "dial_code": "+269", "code": "KM"},
        {"name": "Congo", "label": "Congo", "dial_code": "+242", "code": "CG"},
        {
            "name": "Congo, The Democratic Republic of the Congo",
            "label": "Congo, The Democratic Republic of the Congo",
            "dial_code": "+243",
            "code": "CD"
        },
        {"name": "Cook Islands", "label": "Cook Islands", "dial_code": "+682", "code": "CK"},
        {"name": "Costa Rica", "label": "Costa Rica", "dial_code": "+506", "code": "CR"},
        {"name": "Cote d'Ivoire", "label": "Cote d'Ivoire", "dial_code": "+225", "code": "CI"},
        {"name": "Croatia", "label": "Croatia", "dial_code": "+385", "code": "HR"},
        {"name": "Cuba", "label": "Cuba", "dial_code": "+53", "code": "CU"},
        {"name": "Cyprus", "label": "Cyprus", "dial_code": "+357", "code": "CY"},
        {"name": "Czech Republic", "label": "Czech Republic", "dial_code": "+420", "code": "CZ"},
        {"name": "Denmark", "label": "Denmark", "dial_code": "+45", "code": "DK"},
        {"name": "Djibouti", "label": "Djibouti", "dial_code": "+253", "code": "DJ"},
        {"name": "Dominica", "label": "Dominica", "dial_code": "+1767", "code": "DM"},
        {"name": "Dominican Republic", "label": "Dominican Republic", "dial_code": "+1849", "code": "DO"},
        {"name": "Ecuador", "label": "Ecuador", "dial_code": "+593", "code": "EC"},
        {"name": "Egypt", "label": "Egypt", "dial_code": "+20", "code": "EG"},
        {"name": "El Salvador", "label": "El Salvador", "dial_code": "+503", "code": "SV"},
        {"name": "Equatorial Guinea", "label": "Equatorial Guinea", "dial_code": "+240", "code": "GQ"},
        {"name": "Eritrea", "label": "Eritrea", "dial_code": "+291", "code": "ER"},
        {"name": "Estonia", "label": "Estonia", "dial_code": "+372", "code": "EE"},
        {"name": "Ethiopia", "label": "Ethiopia", "dial_code": "+251", "code": "ET"},
        {
            "name": "Falkland Islands (Malvinas)",
            "label": "Falkland Islands (Malvinas)",
            "dial_code": "+500",
            "code": "FK"
        },
        {"name": "Faroe Islands", "label": "Faroe Islands", "dial_code": "+298", "code": "FO"},
        {"name": "Fiji", "label": "Fiji", "dial_code": "+679", "code": "FJ"},
        {"name": "Finland", "label": "Finland", "dial_code": "+358", "code": "FI"},
        {"name": "France", "label": "France", "dial_code": "+33", "code": "FR"},
        {"name": "French Guiana", "label": "French Guiana", "dial_code": "+594", "code": "GF"},
        {"name": "French Polynesia", "label": "French Polynesia", "dial_code": "+689", "code": "PF"},
        {"name": "Gabon", "label": "Gabon", "dial_code": "+241", "code": "GA"},
        {"name": "Gambia", "label": "Gambia", "dial_code": "+220", "code": "GM"},
        {"name": "Georgia", "label": "Georgia", "dial_code": "+995", "code": "GE"},
        {"name": "Germany", "label": "Germany", "dial_code": "+49", "code": "DE"},
        {"name": "Ghana", "label": "Ghana", "dial_code": "+233", "code": "GH"},
        {"name": "Gibraltar", "label": "Gibraltar", "dial_code": "+350", "code": "GI"},
        {"name": "Greece", "label": "Greece", "dial_code": "+30", "code": "GR"},
        {"name": "Greenland", "label": "Greenland", "dial_code": "+299", "code": "GL"},
        {"name": "Grenada", "label": "Grenada", "dial_code": "+1473", "code": "GD"},
        {"name": "Guadeloupe", "label": "Guadeloupe", "dial_code": "+590", "code": "GP"},
        {"name": "Guam", "label": "Guam", "dial_code": "+1671", "code": "GU"},
        {"name": "Guatemala", "label": "Guatemala", "dial_code": "+502", "code": "GT"},
        {"name": "Guernsey", "label": "Guernsey", "dial_code": "+44", "code": "GG"},
        {"name": "Guinea", "label": "Guinea", "dial_code": "+224", "code": "GN"},
        {"name": "Guinea-Bissau", "label": "Guinea-Bissau", "dial_code": "+245", "code": "GW"},
        {"name": "Guyana", "label": "Guyana", "dial_code": "+595", "code": "GY"},
        {"name": "Haiti", "label": "Haiti", "dial_code": "+509", "code": "HT"},
        {
            "name": "Holy See (Vatican City State)",
            "label": "Holy See (Vatican City State)",
            "dial_code": "+379",
            "code": "VA"
        },
        {"name": "Honduras", "label": "Honduras", "dial_code": "+504", "code": "HN"},
        {"name": "Hong Kong", "label": "Hong Kong", "dial_code": "+852", "code": "HK"},
        {"name": "Hungary", "label": "Hungary", "dial_code": "+36", "code": "HU"},
        {"name": "Iceland", "label": "Iceland", "dial_code": "+354", "code": "IS"},
        {"name": "India", "label": "India", "dial_code": "+91", "code": "IN"},
        {"name": "Indonesia", "label": "Indonesia", "dial_code": "+62", "code": "ID"},
        {
            "name": "Iran, Islamic Republic of Persian Gulf",
            "label": "Iran, Islamic Republic of Persian Gulf",
            "dial_code": "+98",
            "code": "IR"
        },
        {"name": "Iraq", "label": "Iraq", "dial_code": "+964", "code": "IQ"},
        {"name": "Ireland", "label": "Ireland", "dial_code": "+353", "code": "IE"},
        {"name": "Isle of Man", "label": "Isle of Man", "dial_code": "+44", "code": "IM"},
        {"name": "Israel", "label": "Israel", "dial_code": "+972", "code": "IL"},
        {"name": "Italy", "label": "Italy", "dial_code": "+39", "code": "IT"},
        {"name": "Jamaica", "label": "Jamaica", "dial_code": "+1876", "code": "JM"},
        {"name": "Japan", "label": "Japan", "dial_code": "+81", "code": "JP"},
        {"name": "Jersey", "label": "Jersey", "dial_code": "+44", "code": "JE"},
        {"name": "Jordan", "label": "Jordan", "dial_code": "+962", "code": "JO"},
        {"name": "Kazakhstan", "label": "Kazakhstan", "dial_code": "+77", "code": "KZ"},
        {"name": "Kenya", "label": "Kenya", "dial_code": "+254", "code": "KE"},
        {"name": "Kiribati", "label": "Kiribati", "dial_code": "+686", "code": "KI"},
        {
            "name": "Korea, Democratic People's Republic of Korea",
            "label": "Korea, Democratic People's Republic of Korea",
            "dial_code": "+850",
            "code": "KP"
        },
        {
            "name": "Korea, Republic of South Korea",
            "label": "Korea, Republic of South Korea",
            "dial_code": "+82",
            "code": "KR"
        },
        {"name": "Kuwait", "label": "Kuwait", "dial_code": "+965", "code": "KW"},
        {"name": "Kyrgyzstan", "label": "Kyrgyzstan", "dial_code": "+996", "code": "KG"},
        {"name": "Laos", "label": "Laos", "dial_code": "+856", "code": "LA"},
        {"name": "Latvia", "label": "Latvia", "dial_code": "+371", "code": "LV"},
        {"name": "Lebanon", "label": "Lebanon", "dial_code": "+961", "code": "LB"},
        {"name": "Lesotho", "label": "Lesotho", "dial_code": "+266", "code": "LS"},
        {"name": "Liberia", "label": "Liberia", "dial_code": "+231", "code": "LR"},
        {"name": "Libyan Arab Jamahiriya", "label": "Libyan Arab Jamahiriya", "dial_code": "+218", "code": "LY"},
        {"name": "Liechtenstein", "label": "Liechtenstein", "dial_code": "+423", "code": "LI"},
        {"name": "Lithuania", "label": "Lithuania", "dial_code": "+370", "code": "LT"},
        {"name": "Luxembourg", "label": "Luxembourg", "dial_code": "+352", "code": "LU"},
        {"name": "Macao", "label": "Macao", "dial_code": "+853", "code": "MO"},
        {"name": "Macedonia", "label": "Macedonia", "dial_code": "+389", "code": "MK"},
        {"name": "Madagascar", "label": "Madagascar", "dial_code": "+261", "code": "MG"},
        {"name": "Malawi", "label": "Malawi", "dial_code": "+265", "code": "MW"},
        {"name": "Malaysia", "label": "Malaysia", "dial_code": "+60", "code": "MY"},
        {"name": "Maldives", "label": "Maldives", "dial_code": "+960", "code": "MV"},
        {"name": "Mali", "label": "Mali", "dial_code": "+223", "code": "ML"},
        {"name": "Malta", "label": "Malta", "dial_code": "+356", "code": "MT"},
        {"name": "Marshall Islands", "label": "Marshall Islands", "dial_code": "+692", "code": "MH"},
        {"name": "Martinique", "label": "Martinique", "dial_code": "+596", "code": "MQ"},
        {"name": "Mauritania", "label": "Mauritania", "dial_code": "+222", "code": "MR"},
        {"name": "Mauritius", "label": "Mauritius", "dial_code": "+230", "code": "MU"},
        {"name": "Mayotte", "label": "Mayotte", "dial_code": "+262", "code": "YT"},
        {"name": "Mexico", "label": "Mexico", "dial_code": "+52", "code": "MX"},
        {
            "name": "Micronesia, Federated States of Micronesia",
            "label": "Micronesia, Federated States of Micronesia",
            "dial_code": "+691",
            "code": "FM"
        },
        {"name": "Moldova", "label": "Moldova", "dial_code": "+373", "code": "MD"},
        {"name": "Monaco", "label": "Monaco", "dial_code": "+377", "code": "MC"},
        {"name": "Mongolia", "label": "Mongolia", "dial_code": "+976", "code": "MN"},
        {"name": "Montenegro", "label": "Montenegro", "dial_code": "+382", "code": "ME"},
        {"name": "Montserrat", "label": "Montserrat", "dial_code": "+1664", "code": "MS"},
        {"name": "Morocco", "label": "Morocco", "dial_code": "+212", "code": "MA"},
        {"name": "Mozambique", "label": "Mozambique", "dial_code": "+258", "code": "MZ"},
        {"name": "Myanmar", "label": "Myanmar", "dial_code": "+95", "code": "MM"},
        {"name": "Namibia", "label": "Namibia", "dial_code": "+264", "code": "NA"},
        {"name": "Nauru", "label": "Nauru", "dial_code": "+674", "code": "NR"},
        {"name": "Nepal", "label": "Nepal", "dial_code": "+977", "code": "NP"},
        {"name": "Netherlands", "label": "Netherlands", "dial_code": "+31", "code": "NL"},
        {"name": "Netherlands Antilles", "label": "Netherlands Antilles", "dial_code": "+599", "code": "AN"},
        {"name": "New Caledonia", "label": "New Caledonia", "dial_code": "+687", "code": "NC"},
        {"name": "New Zealand", "label": "New Zealand", "dial_code": "+64", "code": "NZ"},
        {"name": "Nicaragua", "label": "Nicaragua", "dial_code": "+505", "code": "NI"},
        {"name": "Niger", "label": "Niger", "dial_code": "+227", "code": "NE"},
        {"name": "Nigeria", "label": "Nigeria", "dial_code": "+234", "code": "NG"},
        {"name": "Niue", "label": "Niue", "dial_code": "+683", "code": "NU"},
        {"name": "Norfolk Island", "label": "Norfolk Island", "dial_code": "+672", "code": "NF"},
        {"name": "Northern Mariana Islands", "label": "Northern Mariana Islands", "dial_code": "+1670", "code": "MP"},
        {"name": "Norway", "label": "Norway", "dial_code": "+47", "code": "NO"},
        {"name": "Oman", "label": "Oman", "dial_code": "+968", "code": "OM"},
        {"name": "Pakistan", "label": "Pakistan", "dial_code": "+92", "code": "PK"},
        {"name": "Palau", "label": "Palau", "dial_code": "+680", "code": "PW"},
        {
            "name": "Palestinian Territory, Occupied",
            "label": "Palestinian Territory, Occupied",
            "dial_code": "+970",
            "code": "PS"
        },
        {"name": "Panama", "label": "Panama", "dial_code": "+507", "code": "PA"},
        {"name": "Papua New Guinea", "label": "Papua New Guinea", "dial_code": "+675", "code": "PG"},
        {"name": "Paraguay", "label": "Paraguay", "dial_code": "+595", "code": "PY"},
        {"name": "Peru", "label": "Peru", "dial_code": "+51", "code": "PE"},
        {"name": "Philippines", "label": "Philippines", "dial_code": "+63", "code": "PH"},
        {"name": "Pitcairn", "label": "Pitcairn", "dial_code": "+872", "code": "PN"},
        {"name": "Poland", "label": "Poland", "dial_code": "+48", "code": "PL"},
        {"name": "Portugal", "label": "Portugal", "dial_code": "+351", "code": "PT"},
        {"name": "Puerto Rico", "label": "Puerto Rico", "dial_code": "+1939", "code": "PR"},
        {"name": "Qatar", "label": "Qatar", "dial_code": "+974", "code": "QA"},
        {"name": "Romania", "label": "Romania", "dial_code": "+40", "code": "RO"},
        {"name": "Russia", "label": "Russia", "dial_code": "+7", "code": "RU"},
        {"name": "Rwanda", "label": "Rwanda", "dial_code": "+250", "code": "RW"},
        {"name": "Reunion", "label": "Reunion", "dial_code": "+262", "code": "RE"},
        {"name": "Saint Barthelemy", "label": "Saint Barthelemy", "dial_code": "+590", "code": "BL"},
        {
            "name": "Saint Helena, Ascension and Tristan Da Cunha",
            "label": "Saint Helena, Ascension and Tristan Da Cunha",
            "dial_code": "+290",
            "code": "SH"
        },
        {"name": "Saint Kitts and Nevis", "label": "Saint Kitts and Nevis", "dial_code": "+1869", "code": "KN"},
        {"name": "Saint Lucia", "label": "Saint Lucia", "dial_code": "+1758", "code": "LC"},
        {"name": "Saint Martin", "label": "Saint Martin", "dial_code": "+590", "code": "MF"},
        {"name": "Saint Pierre and Miquelon", "label": "Saint Pierre and Miquelon", "dial_code": "+508", "code": "PM"},
        {
            "name": "Saint Vincent and the Grenadines",
            "label": "Saint Vincent and the Grenadines",
            "dial_code": "+1784",
            "code": "VC"
        },
        {"name": "Samoa", "label": "Samoa", "dial_code": "+685", "code": "WS"},
        {"name": "San Marino", "label": "San Marino", "dial_code": "+378", "code": "SM"},
        {"name": "Sao Tome and Principe", "label": "Sao Tome and Principe", "dial_code": "+239", "code": "ST"},
        {"name": "Saudi Arabia", "label": "Saudi Arabia", "dial_code": "+966", "code": "SA"},
        {"name": "Senegal", "label": "Senegal", "dial_code": "+221", "code": "SN"},
        {"name": "Serbia", "label": "Serbia", "dial_code": "+381", "code": "RS"},
        {"name": "Seychelles", "label": "Seychelles", "dial_code": "+248", "code": "SC"},
        {"name": "Sierra Leone", "label": "Sierra Leone", "dial_code": "+232", "code": "SL"},
        {"name": "Singapore", "label": "Singapore", "dial_code": "+65", "code": "SG"},
        {"name": "Slovakia", "label": "Slovakia", "dial_code": "+421", "code": "SK"},
        {"name": "Slovenia", "label": "Slovenia", "dial_code": "+386", "code": "SI"},
        {"name": "Solomon Islands", "label": "Solomon Islands", "dial_code": "+677", "code": "SB"},
        {"name": "Somalia", "label": "Somalia", "dial_code": "+252", "code": "SO"},
        {"name": "South Africa", "label": "South Africa", "dial_code": "+27", "code": "ZA"},
        {"name": "South Sudan", "label": "South Sudan", "dial_code": "+211", "code": "SS"},
        {
            "name": "South Georgia and the South Sandwich Islands",
            "label": "South Georgia and the South Sandwich Islands",
            "dial_code": "+500",
            "code": "GS"
        },
        {"name": "Spain", "label": "Spain", "dial_code": "+34", "code": "ES"},
        {"name": "Sri Lanka", "label": "Sri Lanka", "dial_code": "+94", "code": "LK"},
        {"name": "Sudan", "label": "Sudan", "dial_code": "+249", "code": "SD"},
        {"name": "Suriname", "label": "Suriname", "dial_code": "+597", "code": "SR"},
        {"name": "Svalbard and Jan Mayen", "label": "Svalbard and Jan Mayen", "dial_code": "+47", "code": "SJ"},
        {"name": "Swaziland", "label": "Swaziland", "dial_code": "+268", "code": "SZ"},
        {"name": "Sweden", "label": "Sweden", "dial_code": "+46", "code": "SE"},
        {"name": "Switzerland", "label": "Switzerland", "dial_code": "+41", "code": "CH"},
        {"name": "Syrian Arab Republic", "label": "Syrian Arab Republic", "dial_code": "+963", "code": "SY"},
        {"name": "Taiwan", "label": "Taiwan", "dial_code": "+886", "code": "TW"},
        {"name": "Tajikistan", "label": "Tajikistan", "dial_code": "+992", "code": "TJ"},
        {
            "name": "Tanzania, United Republic of Tanzania",
            "label": "Tanzania, United Republic of Tanzania",
            "dial_code": "+255",
            "code": "TZ"
        },
        {"name": "Thailand", "label": "Thailand", "dial_code": "+66", "code": "TH"},
        {"name": "Timor-Leste", "label": "Timor-Leste", "dial_code": "+670", "code": "TL"},
        {"name": "Togo", "label": "Togo", "dial_code": "+228", "code": "TG"},
        {"name": "Tokelau", "label": "Tokelau", "dial_code": "+690", "code": "TK"},
        {"name": "Tonga", "label": "Tonga", "dial_code": "+676", "code": "TO"},
        {"name": "Trinidad and Tobago", "label": "Trinidad and Tobago", "dial_code": "+1868", "code": "TT"},
        {"name": "Tunisia", "label": "Tunisia", "dial_code": "+216", "code": "TN"},
        {"name": "Turkey", "label": "Turkey", "dial_code": "+90", "code": "TR"},
        {"name": "Turkmenistan", "label": "Turkmenistan", "dial_code": "+993", "code": "TM"},
        {"name": "Turks and Caicos Islands", "label": "Turks and Caicos Islands", "dial_code": "+1649", "code": "TC"},
        {"name": "Tuvalu", "label": "Tuvalu", "dial_code": "+688", "code": "TV"},
        {"name": "Uganda", "label": "Uganda", "dial_code": "+256", "code": "UG"},
        {"name": "Ukraine", "label": "Ukraine", "dial_code": "+380", "code": "UA"},
        {"name": "United Arab Emirates", "label": "United Arab Emirates", "dial_code": "+971", "code": "AE"},
        {"name": "United Kingdom", "label": "United Kingdom", "dial_code": "+44", "code": "GB"},
        {"name": "United States", "label": "United States", "dial_code": "+1", "code": "US"},
        {"name": "Uruguay", "label": "Uruguay", "dial_code": "+598", "code": "UY"},
        {"name": "Uzbekistan", "label": "Uzbekistan", "dial_code": "+998", "code": "UZ"},
        {"name": "Vanuatu", "label": "Vanuatu", "dial_code": "+678", "code": "VU"},
        {
            "name": "Venezuela, Bolivarian Republic of Venezuela",
            "label": "Venezuela, Bolivarian Republic of Venezuela",
            "dial_code": "+58",
            "code": "VE"
        },
        {"name": "Vietnam", "label": "Vietnam", "dial_code": "+84", "code": "VN"},
        {"name": "Virgin Islands, British", "label": "Virgin Islands, British", "dial_code": "+1284", "code": "VG"},
        {"name": "Virgin Islands, U.S.", "label": "Virgin Islands, U.S.", "dial_code": "+1340", "code": "VI"},
        {"name": "Wallis and Futuna", "label": "Wallis and Futuna", "dial_code": "+681", "code": "WF"},
        {"name": "Yemen", "label": "Yemen", "dial_code": "+967", "code": "YE"},
        {"name": "Zambia", "label": "Zambia", "dial_code": "+260", "code": "ZM"},
        {"name": "Zimbabwe", "label": "Zimbabwe", "dial_code": "+263", "code": "ZW"}
    ],
};

export const STAR_RATING = [
    {value: 5, label: '05'},
    {value: 10, label: '10'}
]


export const MOODICONS = [
    {label: `calm.png`, value: 'calm'},
    {label: `dull.png`, value: 'dull'},
    {label: `fantastic.png`, value: 'fantastic'},
    {label: `sad.png`, value: 'sad'},
    {label: `sick.png`, value: 'sick'},
    {label: `sleepy.png`, value: 'sleepy'},
];

export const MASTER_DATA_ACTION = {
    REPLACE: 0,
    ADD: 1,
    UPDATE: 2,
    DELETE: 3,
}

export const STRING_LIST = {
    COUNTRY: ['Afghanistan', 'land Islands', 'Albania', 'Algeria', 'American Samoa', 'AndorrA', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, The Democratic Republic of the', 'Cook Islands', 'Costa Rica', 'Cote D\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and Mcdonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic Of', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, Democratic People\'S Republic of', 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan', 'Lao People\'S Democratic Republic', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia, The Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestinian Territory, Occupied', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russian Federation', 'RWANDA', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan, Province of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Viet Nam', 'Virgin Islands, British', 'Virgin Islands, U.S.', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'],
    COLOR: ['#60B158', '#007AFF', '#FFA700', '#FF6961', '#73788B', '#DC2ADE', '#2FB6CE', '#F25FA3', '#43D393', '#8C64FF', '#F4B377', '#757AFF', '#62B7E7', '#90D76F', '#ED93EF', '#7D5A5A', '#6886C5', '#F5B971', '#937D14', '#00BCD4', "#000000", "#0099ff", "#0E71C3", '#FF6961', '#73788B', '#DC2ADE']
}

export const EMP_STATUS = [
    {value: 'all', label: 'All Employees'},
    {value: 'active', label: 'Active Employees'},
    {value: 'inactive', label: 'Inactive Employees'},
];

export const EMP_GROUP_BY = [
    {value: 'location', label: 'Location'},
    {value: 'shift', label: 'Shift'},
    {value: 'department', label: 'Department'},
    {value: 'companyId', label: 'Sub Company'},
    {value: 'jobTitle', label: 'Job Title'}
];
export const UAC_CONSTANT = {
    HOLIDAY: "HOLIDAY",
    IPBLOCKING: "IPBLOCKING",
    OVERTIME: "OVERTIME",
    COMP_OFF: "COMPOFF",
    GEO: "GEO",
    PBD: "PBD",
    SHIFT: "SHIFT",
    PAYROLL_SALARY_TEMPLATE: "PAYROLL_SALARY_TEMPLATE",
    UAC: "UAC",
    WD: "WD",
    NWD: "NWD",
    LEAVE: "LEAVE",
    CLOCK_IN_SETTING: "CLOCK_IN_SETTING",
    POLICY_DOC: "POLICY_DOCUMENT",
    REFERRAL_POLICY: "REFERRAL_POLICY",
    SHIFT_SCHEDULER: "SHIFT_SCHEDULER",
    PRODUCT_ACCESS: "PRODUCT_ACCESS",
    REIMBURSEMENT: 'REIMBURSEMENT_TYPE',
    BIOMETRICS: "BIOMETRICS",
    CHAT_POLICY: "CHAT_POLICY",
}

export const LEAVE = {
    activity: [
        {value: 1, label: 'Created'},
        {value: 2, label: 'Modified'},
        {value: 3, label: 'Deleted'},
        {value: 5, label: 'Short Leave'},
    ],
    dayOptions: [
        {value: 1, label: 'Full Day'},
        {value: 2, label: '1st Half'},
        {value: 3, label: '2nd Half'},
        {value: 5, label: 'Short Leave'},
    ],
    dayStatus: [
        {label: 'HOLIDAY', value: 1},
        {label: 'WEEKEND', value: 2},
        {label: 'WORKING', value: 3},
        {label: 'FIRST_HALF_WORKING', value: 4},
        {label: 'SECOND_HALF_WORKING', value: 5},
        {label: 'FULL_DAY_LEAVE', value: 6},
        {label: 'FIRST_HALF_LEAVE', value: 7},
        {label: 'SECOND_HALF_LEAVE', value: 8},
    ]
}

export const COMPONENT_TYPE = {
    EARNING: 1,
    ADDITIONAL_EARNING: 2,
    DEDUCTION: 3,
    TDS: 4,
    REIMBURSEMENT: 5,
    ARREAR: 6,
    ADVANCE: 7,
    OVER_TIME: 8,
    LEAVE: 9,
    EMPLOYER_SHARE: 10,
    LEAVE_ENCASHMENT: 11,
    FORFEITED: 12,
    EXPENSE: 13,
    LOAN: 14,
    LEAVE_BALANCE: 15,
}

export const MONTH = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
}

export const MONTHS_DAYS = [
    {label: '1', value: 1},
    {label: '2', value: 2},
    {label: '3', value: 3},
    {label: '4', value: 4},
    {label: '5', value: 5},
    {label: '6', value: 6},
    {label: '7', value: 7},
    {label: '8', value: 8},
    {label: '9', value: 9},
    {label: '10', value: 10},
    {label: '11', value: 11},
    {label: '12', value: 12},
    {label: '13', value: 13},
    {label: '14', value: 14},
    {label: '15', value: 15},
    {label: '16', value: 16},
    {label: '17', value: 17},
    {label: '18', value: 18},
    {label: '19', value: 19},
    {label: '20', value: 20},
    {label: '21', value: 21},
    {label: '22', value: 22},
    {label: '23', value: 23},
    {label: '24', value: 24},
    {label: '25', value: 25},
    {label: '26', value: 26},
    {label: '27', value: 27},
    {label: '28', value: 28},
    {label: '29', value: 29},
    {label: '30', value: 30},
    {label: '31', value: 31},
];

export const TIMEZONE_OFFSET = {
    "Etc/GMT+12": 720,
    "Pacific/Niue": 660,
    "Pacific/Pago_Pago": 660,
    "America/Adak": 600,
    "Pacific/Honolulu": 600,
    "Pacific/Rarotonga": 600,
    "Pacific/Tahiti": 600,
    "Pacific/Marquesas": 570,
    "America/Anchorage": 540,
    "America/Juneau": 540,
    "America/Metlakatla": 540,
    "America/Nome": 540,
    "America/Sitka": 540,
    "America/Yakutat": 540,
    "Pacific/Gambier": 540,
    "America/Los_Angeles": 480,
    "America/Tijuana": 480,
    "America/Vancouver": 480,
    "Pacific/Pitcairn": 480,
    "America/Boise": 420,
    "America/Cambridge_Bay": 420,
    "America/Ciudad_Juarez": 420,
    "America/Dawson": 420,
    "America/Dawson_Creek": 420,
    "America/Denver": 420,
    "America/Edmonton": 420,
    "America/Fort_Nelson": 420,
    "America/Hermosillo": 420,
    "America/Inuvik": 420,
    "America/Mazatlan": 420,
    "America/Phoenix": 420,
    "America/Whitehorse": 420,
    "MST": 420,
    "America/Bahia_Banderas": 360,
    "America/Belize": 360,
    "America/Chicago": 360,
    "America/Chihuahua": 360,
    "America/Costa_Rica": 360,
    "America/El_Salvador": 360,
    "America/Guatemala": 360,
    "America/Indiana/Knox": 360,
    "America/Indiana/Tell_City": 360,
    "America/Managua": 360,
    "America/Matamoros": 360,
    "America/Menominee": 360,
    "America/Merida": 360,
    "America/Mexico_City": 360,
    "America/Monterrey": 360,
    "America/North_Dakota/Beulah": 360,
    "America/North_Dakota/Center": 360,
    "America/North_Dakota/New_Salem": 360,
    "America/Ojinaga": 360,
    "America/Rankin_Inlet": 360,
    "America/Regina": 360,
    "America/Resolute": 360,
    "America/Swift_Current": 360,
    "America/Tegucigalpa": 360,
    "America/Winnipeg": 360,
    "CST6CDT": 360,
    "Pacific/Galapagos": 360,
    "America/Bogota": 300,
    "America/Cancun": 300,
    "America/Detroit": 300,
    "America/Eirunepe": 300,
    "America/Grand_Turk": 300,
    "America/Guayaquil": 300,
    "America/Havana": 300,
    "America/Indiana/Indianapolis": 300,
    "America/Indiana/Marengo": 300,
    "America/Indiana/Petersburg": 300,
    "America/Indiana/Vevay": 300,
    "America/Indiana/Vincennes": 300,
    "America/Indiana/Winamac": 300,
    "America/Iqaluit": 300,
    "America/Jamaica": 300,
    "America/Kentucky/Louisville": 300,
    "America/Kentucky/Monticello": 300,
    "America/Lima": 300,
    "America/New_York": 300,
    "America/Panama": 300,
    "America/Port-au-Prince": 300,
    "America/Rio_Branco": 300,
    "America/Toronto": 300,
    "Pacific/Easter": 300,
    "America/Barbados": 240,
    "America/Boa_Vista": 240,
    "America/Campo_Grande": 240,
    "America/Caracas": 240,
    "America/Cuiaba": 240,
    "America/Glace_Bay": 240,
    "America/Goose_Bay": 240,
    "America/Guyana": 240,
    "America/Halifax": 240,
    "America/La_Paz": 240,
    "America/Manaus": 240,
    "America/Martinique": 240,
    "America/Moncton": 240,
    "America/Porto_Velho": 240,
    "America/Puerto_Rico": 240,
    "America/Santo_Domingo": 240,
    "America/Thule": 240,
    "Atlantic/Bermuda": 240,
    "America/St_Johns": 210,
    "America/Araguaina": 180,
    "America/Argentina/Buenos_Aires": 180,
    "America/Argentina/Catamarca": 180,
    "America/Argentina/Cordoba": 180,
    "America/Argentina/Jujuy": 180,
    "America/Argentina/La_Rioja": 180,
    "America/Argentina/Mendoza": 180,
    "America/Argentina/Rio_Gallegos": 180,
    "America/Argentina/Salta": 180,
    "America/Argentina/San_Juan": 180,
    "America/Argentina/San_Luis": 180,
    "America/Argentina/Tucuman": 180,
    "America/Argentina/Ushuaia": 180,
    "America/Asuncion": 180,
    "America/Bahia": 180,
    "America/Belem": 180,
    "America/Cayenne": 180,
    "America/Fortaleza": 180,
    "America/Maceio": 180,
    "America/Miquelon": 180,
    "America/Montevideo": 180,
    "America/Paramaribo": 180,
    "America/Punta_Arenas": 180,
    "America/Recife": 180,
    "America/Santarem": 180,
    "America/Santiago": 180,
    "America/Sao_Paulo": 180,
    "Antarctica/Palmer": 180,
    "Antarctica/Rothera": 180,
    "Atlantic/Stanley": 180,
    "America/Noronha": 120,
    "America/Nuuk": 120,
    "Atlantic/South_Georgia": 120,
    "America/Scoresbysund": 60,
    "Atlantic/Azores": 60,
    "Atlantic/Cape_Verde": 60,
    "Africa/Abidjan": 0,
    "Africa/Bissau": 0,
    "Africa/Monrovia": 0,
    "Africa/Sao_Tome": 0,
    "America/Danmarkshavn": 0,
    "Antarctica/Troll": 0,
    "Atlantic/Canary": 0,
    "Atlantic/Faroe": 0,
    "Atlantic/Madeira": 0,
    "Europe/Dublin": 0,
    "Europe/Lisbon": 0,
    "Europe/London": 0,
    "GMT": 0,
    "Africa/Algiers": -60,
    "Africa/Casablanca": -60,
    "Africa/Ceuta": -60,
    "Africa/El_Aaiun": -60,
    "Africa/Lagos": -60,
    "Africa/Ndjamena": -60,
    "Africa/Tunis": -60,
    "Europe/Andorra": -60,
    "Europe/Belgrade": -60,
    "Europe/Berlin": -60,
    "Europe/Brussels": -60,
    "Europe/Budapest": -60,
    "Europe/Gibraltar": -60,
    "Europe/Madrid": -60,
    "Europe/Malta": -60,
    "Europe/Paris": -60,
    "Europe/Prague": -60,
    "Europe/Rome": -60,
    "Europe/Tirane": -60,
    "Europe/Vienna": -60,
    "Europe/Warsaw": -60,
    "Europe/Zurich": -60,
    "MET": -60,
    "Africa/Cairo": -120,
    "Africa/Johannesburg": -120,
    "Africa/Juba": -120,
    "Africa/Khartoum": -120,
    "Africa/Maputo": -120,
    "Africa/Tripoli": -120,
    "Africa/Windhoek": -120,
    "Asia/Beirut": -120,
    "Asia/Famagusta": -120,
    "Asia/Gaza": -120,
    "Asia/Hebron": -120,
    "Asia/Jerusalem": -120,
    "Asia/Nicosia": -120,
    "EET": -120,
    "Europe/Athens": -120,
    "Europe/Bucharest": -120,
    "Europe/Chisinau": -120,
    "Europe/Helsinki": -120,
    "Europe/Kaliningrad": -120,
    "Europe/Kyiv": -120,
    "Europe/Riga": -120,
    "Europe/Sofia": -120,
    "Europe/Tallinn": -120,
    "Europe/Vilnius": -120,
    "Africa/Nairobi": -180,
    "Asia/Amman": -180,
    "Asia/Baghdad": -180,
    "Asia/Damascus": -180,
    "Asia/Qatar": -180,
    "Asia/Riyadh": -180,
    "Europe/Istanbul": -180,
    "Europe/Kirov": -180,
    "Europe/Minsk": -180,
    "Europe/Moscow": -180,
    "Europe/Simferopol": -180,
    "Europe/Volgograd": -180,
    "Asia/Tehran": -210,
    "Asia/Baku": -240,
    "Asia/Dubai": -240,
    "Asia/Tbilisi": -240,
    "Asia/Yerevan": -240,
    "Europe/Astrakhan": -240,
    "Europe/Samara": -240,
    "Europe/Saratov": -240,
    "Europe/Ulyanovsk": -240,
    "Indian/Mauritius": -240,
    "Asia/Kabul": -270,
    "Antarctica/Mawson": -300,
    "Asia/Aqtau": -300,
    "Asia/Aqtobe": -300,
    "Asia/Ashgabat": -300,
    "Asia/Atyrau": -300,
    "Asia/Dushanbe": -300,
    "Asia/Karachi": -300,
    "Asia/Oral": -300,
    "Asia/Qyzylorda": -300,
    "Asia/Samarkand": -300,
    "Asia/Tashkent": -300,
    "Asia/Yekaterinburg": -300,
    "Indian/Maldives": -300,
    "Asia/Colombo": -330,
    "Asia/Kolkata": -330,
    "Asia/Kathmandu": -345,
    "Asia/Almaty": -360,
    "Asia/Bishkek": -360,
    "Asia/Dhaka": -360,
    "Asia/Omsk": -360,
    "Asia/Qostanay": -360,
    "Asia/Thimphu": -360,
    "Asia/Urumqi": -360,
    "Indian/Chagos": -360,
    "Asia/Yangon": -390,
    "Antarctica/Davis": -420,
    "Asia/Bangkok": -420,
    "Asia/Barnaul": -420,
    "Asia/Ho_Chi_Minh": -420,
    "Asia/Hovd": -420,
    "Asia/Jakarta": -420,
    "Asia/Krasnoyarsk": -420,
    "Asia/Novokuznetsk": -420,
    "Asia/Novosibirsk": -420,
    "Asia/Pontianak": -420,
    "Asia/Tomsk": -420,
    "Asia/Choibalsan": -480,
    "Asia/Hong_Kong": -480,
    "Asia/Irkutsk": -480,
    "Asia/Kuching": -480,
    "Asia/Macau": -480,
    "Asia/Makassar": -480,
    "Asia/Manila": -480,
    "Asia/Shanghai": -480,
    "Asia/Singapore": -480,
    "Asia/Taipei": -480,
    "Asia/Ulaanbaatar": -480,
    "Australia/Perth": -480,
    "Australia/Eucla": -525,
    "Asia/Chita": -540,
    "Asia/Dili": -540,
    "Asia/Jayapura": -540,
    "Asia/Khandyga": -540,
    "Asia/Pyongyang": -540,
    "Asia/Seoul": -540,
    "Asia/Tokyo": -540,
    "Asia/Yakutsk": -540,
    "Pacific/Palau": -540,
    "Australia/Darwin": -570,
    "Asia/Ust-Nera": -600,
    "Asia/Vladivostok": -600,
    "Australia/Brisbane": -600,
    "Australia/Lindeman": -600,
    "Pacific/Guam": -600,
    "Pacific/Port_Moresby": -600,
    "Australia/Adelaide": -630,
    "Australia/Broken_Hill": -630,
    "Antarctica/Casey": -660,
    "Antarctica/Macquarie": -660,
    "Asia/Magadan": -660,
    "Asia/Sakhalin": -660,
    "Asia/Srednekolymsk": -660,
    "Australia/Hobart": -660,
    "Australia/Lord_Howe": -660,
    "Australia/Melbourne": -660,
    "Australia/Sydney": -660,
    "Pacific/Bougainville": -660,
    "Pacific/Efate": -660,
    "Pacific/Guadalcanal": -660,
    "Pacific/Kosrae": -660,
    "Pacific/Noumea": -660,
    "Asia/Anadyr": -720,
    "Asia/Kamchatka": -720,
    "Pacific/Fiji": -720,
    "Pacific/Kwajalein": -720,
    "Pacific/Nauru": -720,
    "Pacific/Norfolk": -720,
    "Pacific/Tarawa": -720,
    "Pacific/Apia": -780,
    "Pacific/Auckland": -780,
    "Pacific/Fakaofo": -780,
    "Pacific/Kanton": -780,
    "Pacific/Tongatapu": -780,
    "Pacific/Chatham": -825,
    "Pacific/Kiritimati": -840
}

export const CURRENCY_LOCALE = {
    "AED": { symbol: "د.إ", language: "ar-AE", name: "UAE Dirham" },
    "AFN": { symbol: "؋", language: "fa-AF", name: "Afghan Afghani" },
    "ALL": { symbol: "L", language: "sq-AL", name: "Albanian Lek" },
    "AMD": { symbol: "֏", language: "hy-AM", name: "Armenian Dram" },
    "ANG": { symbol: "ƒ", language: "nl-AN", name: "Netherlands Antillean Guilder" },
    "AOA": { symbol: "Kz", language: "pt-AO", name: "Angolan Kwanza" },
    "ARS": { symbol: "$", language: "es-AR", name: "Argentine Peso" },
    "AUD": { symbol: "$", language: "en-AU", name: "Australian Dollar" },
    "AWG": { symbol: "ƒ", language: "nl-AW", name: "Aruban Florin" },
    "AZN": { symbol: "₼", language: "az-AZ", name: "Azerbaijani Manat" },
    "BAM": { symbol: "KM", language: "bs-BA", name: "Bosnian Convertible Mark" },
    "BBD": { symbol: "$", language: "en-BB", name: "Barbadian Dollar" },
    "BDT": { symbol: "৳", language: "bn-BD", name: "Bangladeshi Taka" },
    "BGN": { symbol: "лв", language: "bg-BG", name: "Bulgarian Lev" },
    "BHD": { symbol: ".د.ب", language: "ar-BH", name: "Bahraini Dinar" },
    "BIF": { symbol: "FBu", language: "fr-BI", name: "Burundian Franc" },
    "BMD": { symbol: "$", language: "en-BM", name: "Bermudian Dollar" },
    "BND": { symbol: "$", language: "ms-BN", name: "Brunei Dollar" },
    "BOB": { symbol: "Bs.", language: "es-BO", name: "Bolivian Boliviano" },
    "BRL": { symbol: "R$", language: "pt-BR", name: "Brazilian Real" },
    "BSD": { symbol: "$", language: "en-BS", name: "Bahamian Dollar" },
    "BTN": { symbol: "Nu.", language: "dz-BT", name: "Bhutanese Ngultrum" },
    "BWP": { symbol: "P", language: "en-BW", name: "Botswanan Pula" },
    "BYN": { symbol: "Br", language: "be-BY", name: "Belarusian Ruble" },
    "BZD": { symbol: "$", language: "en-BZ", name: "Belize Dollar" },
    "CAD": { symbol: "$", language: "en-CA", name: "Canadian Dollar" },
    "CDF": { symbol: "FC", language: "fr-CD", name: "Congolese Franc" },
    "CHF": { symbol: "CHF", language: "de-CH", name: "Swiss Franc" },
    "CLP": { symbol: "$", language: "es-CL", name: "Chilean Peso" },
    "CNY": { symbol: "¥", language: "zh-CN", name: "Chinese Yuan" },
    "COP": { symbol: "$", language: "es-CO", name: "Colombian Peso" },
    "CRC": { symbol: "₡", language: "es-CR", name: "Costa Rican Colón" },
    "CUC": { symbol: "$", language: "es-CU", name: "Cuban Convertible Peso" },
    "CUP": { symbol: "$", language: "es-CU", name: "Cuban Peso" },
    "CVE": { symbol: "$", language: "pt-CV", name: "Cape Verdean Escudo" },
    "CZK": { symbol: "Kč", language: "cs-CZ", name: "Czech Koruna" },
    "DJF": { symbol: "Fdj", language: "fr-DJ", name: "Djiboutian Franc" },
    "DKK": { symbol: "kr", language: "da-DK", name: "Danish Krone" },
    "DOP": { symbol: "$", language: "es-DO", name: "Dominican Peso" },
    "DZD": { symbol: "د.ج", language: "ar-DZ", name: "Algerian Dinar" },
    "EGP": { symbol: "£", language: "ar-EG", name: "Egyptian Pound" },
    "ERN": { symbol: "Nfk", language: "ti-ER", name: "Eritrean Nakfa" },
    "ETB": { symbol: "Br", language: "am-ET", name: "Ethiopian Birr" },
    "EUR": { symbol: "€", language: "de-DE", name: "Euro" },
    "FJD": { symbol: "$", language: "en-FJ", name: "Fijian Dollar" },
    "FKP": { symbol: "£", language: "en-FK", name: "Falkland Islands Pound" },
    "FOK": { symbol: "kr", language: "fo-FO", name: "Faroese Króna" },
    "GBP": { symbol: "£", language: "en-GB", name: "British Pound" },
    "GEL": { symbol: "₾", language: "ka-GE", name: "Georgian Lari" },
    "GGP": { symbol: "£", language: "en-GG", name: "Guernsey Pound" },
    "GHS": { symbol: "₵", language: "en-GH", name: "Ghanaian Cedi" },
    "GIP": { symbol: "£", language: "en-GI", name: "Gibraltar Pound" },
    "GMD": { symbol: "D", language: "en-GM", name: "Gambian Dalasi" },
    "GNF": { symbol: "FG", language: "fr-GN", name: "Guinean Franc" },
    "GTQ": { symbol: "Q", language: "es-GT", name: "Guatemalan Quetzal" },
    "GYD": { symbol: "$", language: "en-GY", name: "Guyanaese Dollar" },
    "HKD": { symbol: "$", language: "en-HK", name: "Hong Kong Dollar" },
    "HNL": { symbol: "L", language: "es-HN", name: "Honduran Lempira" },
    "HRK": { symbol: "kn", language: "hr-HR", name: "Croatian Kuna" },
    "HTG": { symbol: "G", language: "fr-HT", name: "Haitian Gourde" },
    "HUF": { symbol: "Ft", language: "hu-HU", name: "Hungarian Forint" },
    "IDR": { symbol: "Rp", language: "id-ID", name: "Indonesian Rupiah" },
    "ILS": { symbol: "₪", language: "he-IL", name: "Israeli Shekel" },
    "IMP": { symbol: "£", language: "en-IM", name: "Isle of Man Pound" },
    "INR": { symbol: "₹", language: "hi-IN", name: "Indian Rupee" },
    "IQD": { symbol: "ع.د", language: "ar-IQ", name: "Iraqi Dinar" },
    "IRR": { symbol: "﷼", language: "fa-IR", name: "Iranian Rial" },
    "ISK": { symbol: "kr", language: "is-IS", name: "Icelandic Króna" },
    "JEP": { symbol: "£", language: "en-JE", name: "Jersey Pound" },
    "JMD": { symbol: "$", language: "en-JM", name: "Jamaican Dollar" },
    "JOD": { symbol: "د.ا", language: "ar-JO", name: "Jordanian Dinar" },
    "JPY": { symbol: "¥", language: "ja-JP", name: "Japanese Yen" },
    "KES": { symbol: "Sh", language: "en-KE", name: "Kenyan Shilling" },
    "KGS": { symbol: "лв", language: "ky-KG", name: "Kyrgystani Som" },
    "KHR": { symbol: "៛", language: "km-KH", name: "Cambodian Riel" },
    "KID": { symbol: "$", language: "en-KI", name: "Kiribati Dollar" },
    "KMF": { symbol: "CF", language: "fr-KM", name: "Comorian Franc" },
    "KRW": { symbol: "₩", language: "ko-KR", name: "South Korean Won" },
    "KPW": { symbol: "₩", language: "ko-KP", name: "North Korean Won" },
    "KWD": { symbol: "د.ك", language: "ar-KW", name: "Kuwaiti Dinar" },
    "KYD": { symbol: "$", language: "en-KY", name: "Cayman Islands Dollar" },
    "KZT": { symbol: "〒", language: "kk-KZ", name: "Kazakhstani Tenge" },
    "LAK": { symbol: "₭", language: "lo-LA", name: "Laotian Kip" },
    "LBP": { symbol: "ل.ل", language: "ar-LB", name: "Lebanese Pound" },
    "LKR": { symbol: "Rs", language: "si-LK", name: "Sri Lankan Rupee" },
    "LRD": { symbol: "$", language: "en-LR", name: "Liberian Dollar" },
    "LSL": { symbol: "L", language: "en-LS", name: "Lesotho Loti" },
    "LYD": { symbol: "د.ل", language: "ar-LY", name: "Libyan Dinar" },
    "MAD": { symbol: "د.م.", language: "ar-MA", name: "Moroccan Dirham" },
    "MDL": { symbol: "lei", language: "ro-MD", name: "Moldovan Leu" },
    "MGA": { symbol: "Ar", language: "mg-MG", name: "Malagasy Ariary" },
    "MKD": { symbol: "ден", language: "mk-MK", name: "Macedonian Denar" },
    "MMK": { symbol: "Ks", language: "my-MM", name: "Burmese Kyat" },
    "MNT": { symbol: "₮", language: "mn-MN", name: "Mongolian Tugrik" },
    "MOP": { symbol: "MOP$", language: "zh-MO", name: "Macanese Pataca" },
    "MRO": { symbol: "UM", language: "ar-MR", name: "Mauritanian Ouguiya" },
    "MRU": { symbol: "UM", language: "ar-MR", name: "Mauritanian Ouguiya" },
    "MUR": { symbol: "₨", language: "en-MU", name: "Mauritian Rupee" },
    "MVR": { symbol: "Rf", language: "dv-MV", name: "Maldivian Rufiyaa" },
    "MWK": { symbol: "MK", language: "ny-MW", name: "Malawian Kwacha" },
    "MXN": { symbol: "$", language: "es-MX", name: "Mexican Peso" },
    "MYR": { symbol: "RM", language: "ms-MY", name: "Malaysian Ringgit" },
    "MZN": { symbol: "MT", language: "pt-MZ", name: "Mozambican Metical" },
    "NAD": { symbol: "$", language: "en-NA", name: "Namibian Dollar" },
    "NGN": { symbol: "₦", language: "en-NG", name: "Nigerian Naira" },
    "NIO": { symbol: "C$", language: "es-NI", name: "Nicaraguan Córdoba" },
    "NOK": { symbol: "kr", language: "no-NO", name: "Norwegian Krone" },
    "NPR": { symbol: "Rs", language: "ne-NP", name: "Nepalese Rupee" },
    "NZD": { symbol: "$", language: "en-NZ", name: "New Zealand Dollar" },
    "OMR": { symbol: "ر.ع.", language: "ar-OM", name: "Omani Rial" },
    "PAB": { symbol: "B/.", language: "es-PA", name: "Panamanian Balboa" },
    "PEN": { symbol: "S/", language: "es-PE", name: "Peruvian Nuevo Sol" },
    "PGK": { symbol: "K", language: "en-PG", name: "Papua New Guinean Kina" },
    "PHP": { symbol: "₱", language: "fil-PH", name: "Philippine Peso" },
    "PKR": { symbol: "Rs", language: "ur-PK", name: "Pakistani Rupee" },
    "PLN": { symbol: "zł", language: "pl-PL", name: "Polish Zloty" },
    "PYG": { symbol: "₲", language: "es-PY", name: "Paraguayan Guarani" },
    "QAR": { symbol: "ر.ق", language: "ar-QA", name: "Qatari Rial" },
    "RON": { symbol: "lei", language: "ro-RO", name: "Romanian Leu" },
    "RSD": { symbol: "дин", language: "sr-RS", name: "Serbian Dinar" },
    "RUB": { symbol: "₽", language: "ru-RU", name: "Russian Ruble" },
    "RWF": { symbol: "FRw", language: "rw-RW", name: "Rwandan Franc" },
    "SAR": { symbol: "ر.س", language: "ar-SA", name: "Saudi Riyal" },
    "SBD": { symbol: "$", language: "en-SB", name: "Solomon Islands Dollar" },
    "SCR": { symbol: "₨", language: "fr-SC", name: "Seychellois Rupee" },
    "SDG": { symbol: "ج.س.", language: "ar-SD", name: "Sudanese Pound" },
    "SEK": { symbol: "kr", language: "sv-SE", name: "Swedish Krona" },
    "SGD": { symbol: "$", language: "en-SG", name: "Singapore Dollar" },
    "SHP": { symbol: "£", language: "en-SH", name: "Saint Helena Pound" },
    "SLL": { symbol: "Le", language: "en-SL", name: "Sierra Leonean Leone" },
    "SOS": { symbol: "Sh", language: "so-SO", name: "Somali Shilling" },
    "SRD": { symbol: "$", language: "nl-SR", name: "Surinamese Dollar" },
    "SSP": { symbol: "£", language: "en-SS", name: "South Sudanese Pound" },
    "STN": { symbol: "Db", language: "pt-ST", name: "São Tomé and Príncipe Dobra" },
    "STD": { symbol: "Db", language: "pt-ST", name: "São Tomé and Príncipe Dobra" },
    "SYP": { symbol: "ل.س", language: "ar-SY", name: "Syrian Pound" },
    "SZL": { symbol: "E", language: "en-SZ", name: "Swazi Lilangeni" },
    "THB": { symbol: "฿", language: "th-TH", name: "Thai Baht" },
    "TJS": { symbol: "SM", language: "tg-TJ", name: "Tajikistani Somoni" },
    "TMT": { symbol: "T", language: "tk-TM", name: "Turkmenistani Manat" },
    "TND": { symbol: "د.ت", language: "ar-TN", name: "Tunisian Dinar" },
    "TOP": { symbol: "T$", language: "en-TO", name: "Tongan Paʻanga" },
    "TRY": { symbol: "₺", language: "tr-TR", name: "Turkish Lira" },
    "TTD": { symbol: "$", language: "en-TT", name: "Trinidad and Tobago Dollar" },
    "TVD": { symbol: "$", language: "en-TV", name: "Tuvaluan Dollar" },
    "TWD": { symbol: "NT$", language: "zh-TW", name: "New Taiwan Dollar" },
    "TZS": { symbol: "TSh", language: "sw-TZ", name: "Tanzanian Shilling" },
    "UAH": { symbol: "₴", language: "uk-UA", name: "Ukrainian Hryvnia" },
    "UGX": { symbol: "USh", language: "en-UG", name: "Ugandan Shilling" },
    "USD": { symbol: "$", language: "en-US", name: "United States Dollar" },
    "UYU": { symbol: "$", language: "es-UY", name: "Uruguayan Peso" },
    "UZS": { symbol: "лв", language: "uz-UZ", name: "Uzbekistani Som" },
    "VES": { symbol: "Bs.S.", language: "es-VE", name: "Venezuelan Sovereign Bolívar" },
    "VND": { symbol: "₫", language: "vi-VN", name: "Vietnamese Dong" },
    "VUV": { symbol: "VT", language: "bi-VU", name: "Vanuatu Vatu" },
    "WST": { symbol: "T", language: "sm-WS", name: "Samoan Tala" },
    "XAF": { symbol: "FCFA", language: "fr-CM", name: "CFA Franc BEAC" },
    "XAG": { symbol: "XAG", language: "", name: "Silver Ounce" },
    "XAU": { symbol: "XAU", language: "", name: "Gold Ounce" },
    "XCD": { symbol: "$", language: "en-CB", name: "East Caribbean Dollar" },
    "XDR": { symbol: "XDR", language: "", name: "Special Drawing Rights" },
    "XOF": { symbol: "CFA", language: "fr-BJ", name: "CFA Franc BCEAO" },
    "XPF": { symbol: "CFPF", language: "fr-PF", name: "CFP Franc" },
    "YER": { symbol: "ر.ي", language: "ar-YE", name: "Yemeni Rial" },
    "ZAR": { symbol: "R", language: "en-ZA", name: "South African Rand" },
    "ZMW": { symbol: "ZK", language: "en-ZM", name: "Zambian Kwacha" },
    "ZWL": { symbol: "$", language: "en-ZW", name: "Zimbabwean Dollar" }
}

export const PLAN = {
    attachmentSize: "attachmentSize",
    storage: "storage",
    employee: "emp",
    attendance: "attendance",
    attendanceOnDutyWFH: "attendanceOnDutyWFH",
    attendanceMonthlyAttendance: "attendanceMonthlyAttendance",
    attendanceVerification: "attendanceVerification",
    attendanceAbsentPresent: "attendanceAbsentPresent",
    attendancePresentbyDefault: "attendancePresentbyDefault",
    attendanceNonWorkingDay: "attendanceNonWorkingDay",
    attendanceWorkingDay: "attendanceWorkingDay",
    attendanceShiftCalendar: "attendanceShiftCalendar",
    overtime: "overtime",
    holiday: "holiday",
    leave: "leave",
    leaveCompOff: "leaveCompOff",
    documents: "documents",
    aadhaarCardVerification: 'aadhaarCardVerification',
    panCardVerification: 'panCardVerification',
    aadhaarPanLinkStatus: 'aadhaarPanLinkStatus',
    performance: "performance",
    social: "social",
    helpDesk: "helpDesk",
    onboarding: "onboarding",
    reimbursement: "reimbursement",
    shiftSchedular: "shiftSchedular",
    faceScan: "faceScan",
    biometricsIntegration: "biometricsIntegration",
    geoFencing: "geoFencing",
    geoTagging: "geoTagging",
    settingsSubcompany: "settingsSubcompany",
    settingsLocations: "settingsLocations",
    attendancePenaltyReprocess: "attendancePenaltyReprocess",
    attendanceShiftRequest: "attendanceShiftRequest",
    budget: "budget",
    customField: "customField",
    expense: "expense",
    ipRestriction: "ipRestriction",
    multiplatformLoginRestriction: "multiplatformLoginRestriction",
    productivity: "productivity",
    queryBuilder: "queryBuilder",
    recaptcha: "recaptcha",
    routeMap: "routeMap",
    multiFactorAuthentication: "multiFactorAuthentication",
    runPayroll: "runPayroll",
    importPayroll: "importPayroll",
    earningDeduction: "earningDeduction",
    tdsDeclaration: "tdsDeclaration",
    tdsEarningExemptionBenefit: "tdsEarningExemptionBenefit",
    tdsOverride: "tdsOverride",
    previousEmploymentTds: "previousEmploymentTds",
    taxRegimeReport: "taxRegimeReport",
    advance: "advance",
    arrears: "arrears",
    loan: "loan",
    challan: "challan",
    form16: "form16",
    form12bb: "form12bb",
    form24q: "form24q",
    payrollAnalytics: "payrollAnalytics",
    compareCompensationCost: "compareCompensationCost",
    locationBasedAttendance: "locationBasedAttendance",
    additionalComponentPolicy: "additionalComponentPolicy",
    lwf: "lwf",
    securityDeposit: "securityDeposit",
    gratuitySetting: "gratuitySetting",
    objective: "objective",
    evaluation: "evaluation",
    project: "project",
    projectGanttChart: "projectGanttChart",
    projectMilestones: "projectMilestones",
    projectFiles: "projectFiles",
    projectImportTasks: "projectImportTasks",
    projectMom: "projectMom",
    projectCustomFields: "projectCustomFields",
    tasksCustomFields: "tasksCustomFields",
    projectTemplates: "projectTemplates",
    dependency: "dependency",
    resourceResource: "resourceResource",
    clientList: "clientList",
    upworksIntegration: "upworksIntegration",
    projectDocument: "projectDocument",
    integration: "integration",
    projectForm: "projectForm",
    projectMindMap: "projectMindMap",
    resourcePlanner: "resourcePlanner",
    workDiary: "workDiary",
    jobs: "jobs",
    candidates: "candidates",
    reminder: "reminder",
    interview: "interview",
    requisitions: "requisitions",
    referrals: "referrals",
    zoomIntegration: "zoomIntegration",
    googleMeetIntegration: "googleMeetIntegration",
    teamsIntegration: "teamsIntegration",
    publicPortal: "publicPortal",
    preBoarding: "preBoarding",
}